import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { MaintainersDashboardPage } from './MaintainersDashboardPage';

const maintainersDashboardPage = PageBlueprint.make({
  name: 'maintainers-dashboard',
  params: {
    path: '/maintainers',
    loader: async () => <MaintainersDashboardPage />,
  },
});

export const maintainersModule = createFrontendModule({
  pluginId: 'app',
  extensions: [maintainersDashboardPage],
});

